<template>
    <div>
        <div v-if="!cargando">
            <div class="col-12" id="mapa">
                <!-- Matriz de taquilla: tipo_proceso_taquilla decide el flujo (1 selector clásico,
                     2 secciones/regiones, 3 MapaGeneral); tipo_svg_taquilla decide el mapa de plazas
                     (1 Panzoom, 2 Leaflet). El selector clásico no ofrece Leaflet, secciones/regiones
                     no varían por tecnología y MapaGeneral existe como Leaflet (proceso 3 + tipo 2);
                     las demás combinaciones conservan el renderizado actual. Online no interviene. -->
                <template v-if="evento.place_obj.tipo_proceso_taquilla === 1">
                    <CleSvgComponent
                        v-if="zonas_formated.length > 0"
                        :zonas="zonas_formated"
                        :place="evento.place_obj"
                        :sesion_id="sesion_id"
                        :config_precios="false"
                        @clickZona="goTo" 
                    />
                </template>
                <template v-else>
                    <ul v-if="!dentroDeSector" class="d-flex justify-content-center nav nav-pills">
                        <li class="nav-item">
                            <button
                                :class="tipo_regiones === 1 ? 'nav-link pe-auto active' : 'nav-link pe-auto'"
                                @click="() => this.tipo_regiones = 1"
                            >
                                Svg
                            </button>
                        </li>
                        <li class="nav-item">
                            <button
                                :class="tipo_regiones === 2 ? 'nav-link pe-auto active' : 'nav-link pe-auto'"
                                @click="() => this.tipo_regiones = 2"
                            >
                                Listado
                            </button>
                        </li>
                    </ul>
                    <hr/>
                    <SeccionesComponent
                        ref="secciones"
                        v-show="tipo_regiones === 1"
                        :event="evento"
                        :sesion_id="parseInt(sesion_id)"
                        :abonado_id="abonadoId"
                        @terminar="goTo(2, $event)"
                        @cambio-nivel="dentroDeSector = $event"
                    />
                    <TablaSectoresComponent
                        v-if="tipo_regiones === 2"
                        :zonas="zonas_formated"
                        @goTo="goTo"
                    />
                </template>
                <h3 v-if="zonas && evento.place_obj.tipo_proceso_taquilla === 1">
                    <b>Libres: </b>
                    {{ total_libres }}
                </h3>
            </div>
            <div class="col-12" v-if="(configuracion.hash_teatro === 'MtDVv542o0x8qfp47N5p' && evento.place_obj.tipo_svg === 1) || evento.place_obj.tipo_proceso_taquilla === 1">
                <TablaSectoresComponent :zonas="zonas_formated" @goTo="goTo" />
            </div>
        </div>
        <div class="col-12" v-else>
            <LoaderComponent />
        </div>
    </div>
</template>

<script>
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';
    import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent';
    import SeccionesComponent from '@/components/frontend/events/compra/components/secciones/SeccionesComponent';
    import { useAmigoAbonadoTaquilla } from '@/composables/admin/events/useAmigoAbonadoTaquilla';

    const { formatearZonaAmigoAbonado } = useAmigoAbonadoTaquilla();

    export default {
        props: ['evento', 'sesion_id', 'mode', 'asientos','datos_compradores', 'entradas', 'puede_cambiar', 'abonado_id'],
        data() {
            return {
                zonas: {},
                cargando: false,
                tipo_regiones: 1,
                dentroDeSector: false,
                // Un solo aviso de mapa pintado por montaje: el padre enlaza su
                // desplazamiento a ese aviso y no debe repetirlo.
                mapa_observado: false,
                mapa_avisado: false
            }
        },
        created() {
            // Tipo 1 necesita las zonas del svg clásico y tipo 2 el listado del mapa
            // nuevo. El resto conserva su carga actual (incluida la excepción del teatro).
            if(this.evento && this.evento.tiene_recinto && ((this.configuracion.hash_teatro === 'MtDVv542o0x8qfp47N5p' && this.evento.place_obj.tipo_svg === 1) || this.evento.place_obj.tipo_proceso_taquilla === 1 || this.evento.place_obj.tipo_proceso_taquilla === 2)) {
                this.getZonas();
            }            
        },
        watch: {
            /**
             * El mapa no está listo cuando llegan las zonas: el SVG de
             * secciones/regiones se pide aparte y el bloque crece cuando entra. En
             * cuanto terminan las peticiones del selector se enlaza el aviso al
             * pintado real del mapa hijo.
             */
            cargando(cargando) {
                if (!cargando) {
                    this.$nextTick(this.enlazarAvisoMapaListo);
                }
            }
        },
        mounted() {
            // Ramas que no piden zonas (mapa general o evento sin recinto): no hay cambio
            // de `cargando` que esperar, así que el aviso se enlaza al montar.
            if (!this.cargando) {
                this.$nextTick(this.enlazarAvisoMapaListo);
            }
        },
        computed: {
            total_libres() {
                let total = 0;

                if (this.zonas_formated && this.zonas_formated.length > 0) {
                    for (let i = 0; i < this.zonas_formated.length; i++) {
                        const zona = this.zonas_formated[i];
                        if (zona.name !== 'Internacional' && 
                            zona.name !== 'Baby' &&
                            zona.name !== 'internacional' &&
                            zona.name !== 'INTERNACIONAL' &&
                            zona.esta_disponible) {

                            let libres = 0;

                            if (zona.tiene_recinto) {
                                libres = zona.libres;
                            } else {
                                libres = zona.with_seats ? zona.total_asientos : zona.aforo;
                                libres = libres - zona.bloqueados - zona.confirmados - zona.no_confirmados - zona.sesion;   
                            }

                            total += libres;
                        }
                    }
                }

                return total;
            },
            zonas_formated() {
                let array = [];

                if(this.mode != 2) {
                    if(this.esModoAmigoAbonado) {
                        for(const zona of Object.values(this.zonas)) {
                            array.push(formatearZonaAmigoAbonado(zona));
                        }
                    } else {
                        for(let zona_n in this.zonas) {
                            array.push(Object.assign({}, this.zonas[zona_n]));
                            let disponible_n = array[zona_n].precios.length > 0 && array[zona_n].esta_disponible ? true : false;
                            array[zona_n].esta_disponible = disponible_n;
                        }
                    }
                } else {
                    for(let zona in this.zonas) {
                        array.push(Object.assign({}, this.zonas[zona]));

                        const preciosAbonados = array[zona].precios_abonados;
                        const tienePreciosAbonados = Array.isArray(preciosAbonados) && preciosAbonados.length > 0;
                        array[zona].precios = tienePreciosAbonados
                            ? preciosAbonados
                            : (Array.isArray(array[zona].precios) ? array[zona].precios : []);

                        let disponible = array[zona].precios.length > 0 && array[zona].esta_disponible ? true : false;
                        array[zona].esta_disponible = disponible;
                    }
                }

                return array;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            /**
             * Id del abonado en el modo día del abonado, para que el mapa de
             * secciones reciba sus tarifas. En ese modo `datos_compradores[0].id`
             * puede ser el id de la plaza (abono de región anexa), así que la
             * fuente fiable es `abonado_id`. En el resto de modos no se envía.
             */
            /**
             * El modo puede llegar como cadena desde algún contenedor; comparar
             * numéricamente evita que la rama del día del abonado no se ejecute y el
             * mapa emita su `goTo` sin los datos del abonado (lo que rompía el flujo
             * en `finalizarPasoUno`).
             */
            esModoAbonado() {
                return Number(this.mode) === 2;
            },
            abonadoId() {
                if (!this.esModoAbonado) {
                    return null;
                }

                // La venta de taquilla vacía `datos_compradores` justo cuando el abonado va
                // a elegir otro asiento (su butaca no está disponible), así que el id llega
                // por prop y sobrevive a ese vaciado. `datos_compradores` queda como
                // respaldo para quien monte el selector sin la prop.
                if (this.abonado_id !== undefined && this.abonado_id !== null && this.abonado_id !== '') {
                    return this.abonado_id;
                }

                const comprador = Array.isArray(this.datos_compradores) ? this.datos_compradores[0] : null;

                if (!comprador) {
                    return null;
                }

                return comprador.abonado_id ?? comprador.id ?? null;
            },
            esModoAmigoAbonado() {
                return Number(this.mode) === 3;
            },
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        methods: {
            /**
             * El padre (la venta del día del abonado) desplaza la vista a este bloque
             * solo cuando recibe `mapa-listo`. Si lo hiciera antes, el bloque crecería
             * después con el SVG y el salto se vería como un tirón, así que el aviso se
             * emite cuando el mapa ya está cargado y pintado.
             */
            enlazarAvisoMapaListo() {
                if (this.mapa_observado || this.mapa_avisado) {
                    return;
                }

                const secciones = this.$refs.secciones;

                // El svg clásico (`CleSvgComponent`) no expone su carga al selector: sin
                // bandera que esperar, se avisa al terminar las zonas para no dejar la
                // vista sin bajar.
                if (!secciones || typeof secciones.paso1_loading !== 'boolean') {
                    this.avisarMapaListo();
                    return;
                }

                this.mapa_observado = true;

                // El mapa hijo mantiene su loader hasta que el SVG ya está inyectado:
                // ésa es la señal de que el bloque tiene su altura definitiva.
                if (!secciones.paso1_loading) {
                    this.avisarMapaListo();
                    return;
                }

                secciones.$watch('paso1_loading', pintando => {
                    if (!pintando) {
                        // Un tick más para que la altura del bloque ya esté aplicada.
                        this.$nextTick(this.avisarMapaListo);
                    }
                });
            },
            avisarMapaListo() {
                if (this.mapa_avisado || this.cargando) {
                    return;
                }

                this.mapa_avisado = true;
                this.$emit('mapa-listo');
            },
            goTo(paso, zona) {
                if (this.esModoAbonado) {
                    let datos_compradores = this.datos_compradores;

                    datos_compradores.precios = zona.precios;

                    let abonado = {
                        dia_abonado: 1,
                        datos_compradores: datos_compradores,
                        entradas: this.entradas,
                        asientos: this.asientos,
                        puede_cambiar: this.puede_cambiar
                    }
                    this.$emit('goTo', paso, zona, abonado);

                } else {
                    this.$emit('goTo', paso, zona);
                }
            },
            getZonas() {
                this.cargando = true;
                let params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id
                    }
                };

                const abonadoId = this.abonadoId;
                if(abonadoId != null) {
                    params.filters.abonado_id = abonadoId;
                }

                const zonasAlias = this.config.getVuexAlias('zonas.index');
                this.$store.dispatch(zonasAlias, params).then(res => {
                    if (abonadoId == null || res.data.length > 0) {
                        return res;
                    }

                    return this.$store.dispatch(zonasAlias, {
                        filters: {
                            evento_id: params.filters.evento_id,
                            sesion_id: params.filters.sesion_id
                        }
                    });
                }).then(res => {
                    this.zonas = res.data;
                    if (this.place) {
                        this.getZonasAnexas();
                    } else {
                        this.cargando = false;
                    }
                    this.$emit('getZonasFormateadas', this.zonas_formated);

                });
            },
            getZonasAnexas() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        ...(this.esModoAmigoAbonado ? { amigo_abonado: 1 } : {})
                    },
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    recinto_id: this.place.id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.zonas-anexas'), params).then(res => {
                    // El selector de zona es el primer paso de la venta: no se salta solo
                    // aunque no haya zonas principales disponibles y exista una única región
                    // anexa con precios (antes emitía `goTo(2, ...)` y se perdía el paso).
                    this.zonas = this.zonas.concat(res.data.data);
                    this.$nextTick(() => {
                        this.$scrollTo('#mapa', 100);
                    })
                }).finally(() => this.cargando = false);
            },
        },
        components: {
            CleSvgComponent, TablaSectoresComponent, SeccionesComponent
        }
    }
</script>